import { useEffect } from 'react';

import { captureException } from '@sentry/browser';
import { useDailyPauseCalendarReminderQuery } from 'src/modules/scheduledContent/documents/getDailyPauseCalendarReminder.generated';

export type DailyPauseCalendarUrls = 'googleCalendarUrl' | 'icsUrl';

export const useDailyPauseReminderCalendarUrls = () => {
    const { data, loading, error } = useDailyPauseCalendarReminderQuery();

    const handleReminderCreation = (calendarUrlType: DailyPauseCalendarUrls) => {
        if (data?.dailyPauseCalendarReminder?.[calendarUrlType]) {
            window.open(data.dailyPauseCalendarReminder[calendarUrlType], '_blank');
        } else {
            captureException(`No ${calendarUrlType} event link`);
        }
    };

    useEffect(() => {
        if (error) {
            captureException(error);
        }
    }, [error]);

    return {
        data,
        loading,
        error,
        handleReminderCreation,
    };
};
